interface CommentIconProps {
  /** When true, shows filled icon with lines (has comments). When false, shows outline icon (no comments). */
  hasComments?: boolean;
}

export default function CommentIcon({
  hasComments = false
}: Readonly<CommentIconProps>) {
  if (hasComments) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M3.99992 9.33334H11.9999V8.00001H3.99992V9.33334ZM3.99992 7.33334H11.9999V6.00001H3.99992V7.33334ZM3.99992 5.33334H11.9999V4.00001H3.99992V5.33334ZM14.6666 14.6667L11.9999 12H2.66659C2.29992 12 1.98603 11.8695 1.72492 11.6083C1.46381 11.3472 1.33325 11.0333 1.33325 10.6667V2.66668C1.33325 2.30001 1.46381 1.98612 1.72492 1.72501C1.98603 1.4639 2.29992 1.33334 2.66659 1.33334H13.3333C13.6999 1.33334 14.0138 1.4639 14.2749 1.72501C14.536 1.98612 14.6666 2.30001 14.6666 2.66668V14.6667ZM2.66659 10.6667H12.5666L13.3333 11.4167V2.66668H2.66659V10.6667Z"
          fill="#4448C1"
        />
      </svg>
    );
  }

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 14L11.2 11.2H1.4C1.015 11.2 0.685417 11.0629 0.41125 10.7887C0.137083 10.5146 0 10.185 0 9.8V1.4C0 1.015 0.137083 0.685417 0.41125 0.41125C0.685417 0.137083 1.015 0 1.4 0H12.6C12.985 0 13.3146 0.137083 13.5887 0.41125C13.8629 0.685417 14 1.015 14 1.4V14ZM1.4 9.8H11.795L12.6 10.5875V1.4H1.4V9.8Z"
        fill="#4448C1"
      />
    </svg>
  );
}
